"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCetEvents = exports.default = void 0;
var _react = require("react");
var _useScripts2 = require("./useScripts");
var _urls = require("../utilities/urls");
var _useSessionData2 = require("./useSessionData");
var _CetComponentsProvider = require("../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useScriptsList = {
  scriptsList: [{
    src: "".concat(_urls.apiGatewayUrl, "/bigdataapi/provider/BigDataProvider.js"),
    isWaitUntilLoaded: false,
    checkIfAlreadyLoaded: function checkIfAlreadyLoaded() {
      return window.cet && window.cet.microservices && window.cet.microservices.bigData;
    }
  }]
};
var useCetEvents = function useCetEvents() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    siteKey = _useContext.siteKey,
    language = _useContext.language;
  var _useScripts = (0, _useScripts2.useScripts)(useScriptsList),
    isReady = _useScripts.isReady,
    error = _useScripts.error;
  var _useSessionData = (0, _useSessionData2.useSessionData)(),
    isSessionDataReady = _useSessionData.isSessionDataReady,
    sessionId = _useSessionData.sessionId,
    userId = _useSessionData.userId,
    role = _useSessionData.role,
    schoolId = _useSessionData.schoolId;
  var unsentEventsQueue = (0, _react.useRef)([]);
  var GUEST_ID = '00000000-0000-0000-0000-000000000000';
  var GUEST = 'guest';
  (0, _react.useEffect)(function () {
    var _unsentEventsQueue$cu;
    if (isSessionDataReady && isReady && ((_unsentEventsQueue$cu = unsentEventsQueue.current) === null || _unsentEventsQueue$cu === void 0 ? void 0 : _unsentEventsQueue$cu.length) > 0) {
      unsentEventsQueue.current.forEach(function (eventSenderFunc) {
        eventSenderFunc === null || eventSenderFunc === void 0 ? void 0 : eventSenderFunc();
      });
      unsentEventsQueue.current = [];
    }
  }, [isSessionDataReady, isReady, unsentEventsQueue]);
  var getOptionalParams = (0, _react.useCallback)(function (optionalData, lang, eventData) {
    var optionalParams = {
      currentHyperlink: eventData.currentHyperlink,
      schoolId: schoolId,
      sessionId: sessionId,
      contentLanguage: lang,
      objectAdditionalInformation: {}
    };
    optionalParams = _objectSpread(_objectSpread({}, optionalParams), optionalData);
    optionalParams.objectAdditionalInformation = optionalData.objectAdditionalInformation || {};
    return optionalParams;
  }, [schoolId, sessionId]);
  var sendEvent = (0, _react.useCallback)(function (func) {
    if (isSessionDataReady) {
      var _useScriptsList$scrip, _useScriptsList$scrip2;
      if ((_useScriptsList$scrip = (_useScriptsList$scrip2 = useScriptsList.scriptsList[0]).checkIfAlreadyLoaded) !== null && _useScriptsList$scrip !== void 0 && _useScriptsList$scrip.call(_useScriptsList$scrip2)) {
        func();
      } else {
        if (error) {
          console.error('Error while trying to send event', error);
        } else {
          unsentEventsQueue.current.push(func);
        }
      }
    }
  }, [isSessionDataReady, error, unsentEventsQueue]);
  var sendUiUsageEvent = (0, _react.useCallback)(function (data) {
    if (!data.contextReferrer) {
      var _contextReferrer;
      data.contextReferrer = (_contextReferrer = window.contextReferrer) !== null && _contextReferrer !== void 0 ? _contextReferrer : window.location.href;
    }
    if (!data.currentHyperlink) {
      var _currentHyperlink;
      data.currentHyperlink = (_currentHyperlink = window.currentHyperlink) !== null && _currentHyperlink !== void 0 ? _currentHyperlink : window.location.href;
    }
    sendEvent(function () {
      var requestData = {
        verb: data.verb || 'pressed',
        category: data.category,
        label: data.label,
        contextReferrer: data.contextReferrer,
        optionalData: data.optionalData || {}
      };
      var uiUsageObjectName = requestData.label;
      var uiUsageObjectId = siteKey + '~' + requestData.category + '~' + requestData.label;
      var uiUsageObjectType = 'inputControl';
      var optionalParams = getOptionalParams(requestData.optionalData, language, data);
      try {
        window.cet.microservices.bigData.messages.sendUiUsageEvent(window.cet.microservices.bigData.enums.verbs[requestData.verb], uiUsageObjectId, uiUsageObjectName, window.cet.microservices.bigData.enums.objectTypes[uiUsageObjectType], siteKey, requestData.contextReferrer, role || GUEST, userId || GUEST_ID, optionalParams);
      } catch (ex) {
        console.error(ex);
      }
    });
  }, [getOptionalParams, language, role, sendEvent, siteKey, userId]);
  var sendLearningEvent = (0, _react.useCallback)(function (data) {
    if (!data.contextReferrer) {
      var _contextReferrer2;
      data.contextReferrer = (_contextReferrer2 = window.contextReferrer) !== null && _contextReferrer2 !== void 0 ? _contextReferrer2 : window.location.href;
    }
    if (!data.currentHyperlink) {
      var _currentHyperlink2;
      data.currentHyperlink = (_currentHyperlink2 = window.currentHyperlink) !== null && _currentHyperlink2 !== void 0 ? _currentHyperlink2 : window.location.href;
    }
    sendEvent(function () {
      var _data$optionalData;
      var requestData = {
        verbType: data.verbType,
        objectId: data.objectId,
        objectName: data.objectName,
        objectType: data.objectType || 'webpage',
        contextReferrer: data.contextReferrer,
        optionalData: (_data$optionalData = data.optionalData) !== null && _data$optionalData !== void 0 ? _data$optionalData : {}
      };
      var optionalParams = getOptionalParams(requestData.optionalData, language, data);
      try {
        window.cet.microservices.bigData.messages.sendLearningEvent(window.cet.microservices.bigData.enums.verbs[requestData.verbType], requestData.objectId, requestData.objectName, window.cet.microservices.bigData.enums.objectTypes[requestData.objectType], siteKey, requestData.contextReferrer, role !== null && role !== void 0 ? role : GUEST, userId !== null && userId !== void 0 ? userId : GUEST_ID, optionalParams);
      } catch (ex) {
        console.error(ex);
      }
    });
  }, [getOptionalParams, language, role, sendEvent, siteKey, userId]);
  return {
    sendUiUsageEvent: sendUiUsageEvent,
    sendLearningEvent: sendLearningEvent
  };
};
exports.useCetEvents = useCetEvents;
var _default = useCetEvents;
exports.default = _default;